<app-input-select
  idField="istatComune"
  labelField="denominazione"
  [list]="comuni"
  [name]="name"
  label="Comune"
  icon="location_city"
  [form]="form"
  [searchComponentTemplate]="searchTemplate"
  placeholder="Seleziona un comune"
>
</app-input-select>
